<template>
  <!-- 公司介绍swiper组件 图片列表 -->
  <div class="swiper" id="certify">
    <div class="swiper-container">
      <div class="swiper-wrapper">
        <div class="swiper-slide" v-for="item in certifyList" :key="item.id" :style="certifyList.length > 1 ? 'margin: 0px;':'margin: 0px auto;'">
          <img :src="item.url" :alt="$i18n.locale === 'en-US' ? 'GZZHYUN certification' : '智会云公司资质'" />
          <p><span>{{item.desc}}</span></p>
        </div>

      </div>
    </div>
    <div class="swiper-pagination"></div>
    <div class="swiper-button-prev"></div>
    <div class="swiper-button-next"></div>
  </div>
</template>

<script>
import Swiper from 'swiper'
import 'swiper/dist/js/swiper.min.js'
import 'swiper/dist/css/swiper.min.css'
import '../../assets/css/certify.css'
import { getCertifyList } from '@/api/editHome'
export default {
  methods: {
    // 根据屏幕宽度动态计算位移
    getTranslateStep () {
      const w = window.innerWidth
      if (w <= 576) return 90
      if (w <= 768) return 120
      if (w <= 1200) return 180
      return 260
    },
    // 获取轮播图列表
    getCertifyList () {
      getCertifyList().then(res => {
        if (res.code == 0) {
          this.certifyList = res.data
        } else {
          this.$message.error(res.msg)
        }
      })
    }
  },
  mounted () {
    const vm = this
    this.$nextTick(() => {
      setTimeout(() => {
        if (this.certifyList.length > 1) {
          new Swiper('#certify .swiper-container', {
            watchSlidesProgress: true,
            slidesPerView: 'auto',
            centeredSlides: true,
            loop: true,
            loopedSlides: 5,
            autoplay: {
              disableOnInteraction: false
            },
            navigation: {
              nextEl: '#certify .swiper-button-next',
              prevEl: '#certify .swiper-button-prev'
            },
            pagination: {
              el: '.swiper-pagination'
              // 点击小白点无效
              // clickable :true,
            },
            on: {
              progress: function (progress) {
                const step = vm.getTranslateStep()
                for (let i = 0; i < this.slides.length; i++) {
                  var slide = this.slides.eq(i)
                  var slideProgress = this.slides[i].progress
                  var modify = 1
                  if (Math.abs(slideProgress) > 1) {
                    modify = (Math.abs(slideProgress) - 1) * 0.3 + 1
                  }
                  var translate = slideProgress * modify * step + 'px'
                  var scale = 1 - Math.abs(slideProgress) / 5
                  var zIndex = 999 - Math.abs(Math.round(10 * slideProgress))
                  slide.transform('translateX(' + translate + ') scale(' + scale + ')')
                  slide.css('zIndex', zIndex)
                  slide.css('opacity', 1)
                  if (Math.abs(slideProgress) > 3) {
                    slide.css('opacity', 0)
                  }
                }
              },
              setTransition: function (transition) {
                for (let i = 0; i < this.slides.length; i++) {
                  var slide = this.slides.eq(i)
                  slide.transition(transition)
                }
              }
            }
          })
        }
      }, 1000)
    })
  },
  data () {
    return {
      certifyList: []
    }
  },
  created () {
    this.getCertifyList()
  }
}
</script>

<style lang="less" scoped>
.swiper{
  margin-top: 40px !important;
  margin-bottom: 60px !important;
}
.swiper-slide{
  padding: 20px;
  box-sizing: border-box;
  border-radius: 20px;
  border: 1px solid #CECECE;
  img{
    width: 100%;
    height: auto;
  }
  p{
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    line-height: 28px !important;
    min-height: 56px !important;
    max-height: 56px !important;
    margin: 0 !important;
    padding: 2px 0 !important;
    text-align: center !important;
  }
  p span{
    width: 100% !important;
    word-break: break-word !important;
    overflow-wrap: anywhere !important;
    hyphens: auto !important;
    white-space: normal !important;
    overflow: hidden !important;
    text-overflow: ellipsis !important;
    display: -webkit-box !important;
    -webkit-box-orient: vertical !important;
    -webkit-line-clamp: 2 !important;
    line-clamp: 2 !important;
  }
}

@media (max-width: 767.98px) {
  .swiper{
    margin-top: 20px !important;
    margin-bottom: 30px !important;
  }

  .swiper-slide {
    padding: 10px;
    p{
      line-height: 24px !important;
      min-height: 48px !important;
      max-height: 48px !important;
      display: flex !important;
      align-items: center !important;
      justify-content: center !important;
      margin: 0 !important;
      padding: 2px 0 !important;
      text-align: center !important;
    }
    p span{
      width: 100% !important;
      word-break: break-word !important;
      overflow-wrap: anywhere !important;
      hyphens: auto !important;
      white-space: normal !important;
      overflow: hidden !important;
      display: -webkit-box !important;
      -webkit-box-orient: vertical !important;
      -webkit-line-clamp: 2 !important;
      line-clamp: 2 !important;
    }
  }
}
</style>
